export default __webpack_public_path__ + "static/1-59605bf36a71a0533048fededa1b9d3e.jpeg";